module.exports = __webpack_public_path__ + "static/img/project_banner3.c8be781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_banner3.png
// module id = ic2g
// module chunks = 1